// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ee9bf310","977":"196f5fa2"}[chunkId] + ".chunk.js";
};